import { get } from 'lodash';
import { AppState } from '../root.reducer';

export const getTenancyById = (id: string) => (state: AppState) => get(state, `entities.tenancy.${id}`);
